import React from 'react'
import { Route, Routes } from 'react-router-dom'

import { ProjectThemeProvider } from './context/ProjectThemeContext'
import UI from './components/UI/UI'
import Home from './pages/Home'
// import About from './pages/About'
import Portfolio from './pages/Portfolio'
import FantabulousFreddPrivacy from './pages/FantabulousFreddPrivacy'
import FantabulousFreddTerms from './pages/FantabulousFreddTerms'
import OraleTaqueroPrivacy from './pages/OraleTaqueroPrivacy'

// import Contact from './pages/Contact'

function App() {
	return (
		<ProjectThemeProvider>
			<UI>
				<Routes>
					<Route path="*" element={ <h1>Error 404</h1> } />

					<Route path="/" element={ <Home /> } />
					{/* <Route path="/sobre-nosotros" element={ <About /> } /> */}
					<Route path="/portafolio" element={ <Portfolio /> } />
					{/* <Route path="/contactanos" element={ <Contact /> } /> */}
					<Route path="fantabulous-fredd-privacy" element={ <FantabulousFreddPrivacy />} />
					<Route path="fantabulous-fredd-terms" element={ <FantabulousFreddTerms />} />

					<Route path="/orale-taquero-privacy" element={ <OraleTaqueroPrivacy />} />
				</Routes>
			</UI>
		</ProjectThemeProvider>
	)
}

export default App
